import React from 'react';
import '../index.css';

function About() {
  return (
    <div className="container">
      <h3>About me</h3>
      <p>
        Hi, I am Himanshu Saini, a 27 year old scholar living in Delhi, India. I am a Computer
        Science Engineer working with awesome folks in US healthcare industry.
        <br />
        <br /> Often I can be found building tech. I ❤️ trek explorations, computers, and fiction.
        The project is devoted to paa, maa,and my partner in crime.
      </p>
    </div>
  );
}

export default About;
